import { injectFeatureReducer } from '@/platform/state/reducerRegistry'
import { membershipsReducer } from './membershipsSlice'
export function registerMembershipsStore(): void { injectFeatureReducer('memberships', membershipsReducer) }
